import { SVGAttributes } from 'react'

const FunnelIcon = (props: SVGAttributes<SVGElement>) => (
    <svg
        fill={props.color || 'white'}
        width="20"
        height="18"
        viewBox="10 10 20 18"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <defs>
            <linearGradient x1="50%" y1="99.9783057%" x2="62.5547978%" y2="-22.3622842%" id="funnel">
                <stop id="gradient-stop-1" offset="0%" stopColor="var(--stop-color-1)" />
                <stop id="gradient-stop-2" offset="100%" stopColor="var(--stop-color-2)" />
            </linearGradient>
        </defs>
        <path
            d="M22.457 26a.284.284 0 0 0 .209-.086.284.284 0 0 0 .085-.209v-4.812l5.106-7.533a.847.847 0 0 0 .144-.437.841.841 0 0 0-.096-.451c-.178-.315-.437-.472-.78-.472H14.877c-.341 0-.601.157-.779.472a.841.841 0 0 0-.095.45c.009.165.056.31.143.438l5.106 7.533v4.812c0 .082.029.152.086.209a.284.284 0 0 0 .208.085h2.912Z"
            fill="url(#funnel)"
        />
    </svg>
)
export default FunnelIcon
